module.exports = __webpack_public_path__ + "img/logo.ce221b4f.png";